'use client';

import Link from 'next/link';
import {usePathname} from 'next/navigation';
import {SidebarMenuButton, SidebarMenuItem, useSidebar} from '@manaboo/ui/sidebar';

interface SidebarLinkProps {
	title: string;
	url: string;
	icon: React.ReactNode;
}

export function SidebarLink({title, url, icon}: SidebarLinkProps) {
	const pathname = usePathname();
	const {toggleSidebar} = useSidebar();

	return (
		<SidebarMenuItem key={title}>
			<SidebarMenuButton
				asChild
				isActive={pathname === url}
			>
				<Link
					href={url}
					onClick={toggleSidebar}
				>
					{icon}
					<span>{title}</span>
				</Link>
			</SidebarMenuButton>
		</SidebarMenuItem>
	);
}
